<template>
  <div>
    <!-- BEGIN CONTENT BODY -->
    <!-- BEGIN PAGE HEADER-->
    <breadcrumbs
      :crumbs="[{name:`${participantSingularName} Dashboard`, link:'Dashboard Participant', id: $route.params.id},{name:'Messagess'}]"
    />
    <!--END PAGE HEADER-->
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-6 db-column" id="first-column">
            <profile-participant></profile-participant>
          </div>
          <div class="col-md-6 db-column" id="second-column">
            <assingment></assingment>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <messages/>
          </div>
        </div>
      </div>
      <div class="col-md-4 db-column" id="third-column">
        <case-notes></case-notes>
      </div>
    </div>
    <!--END CONTENT BODY-->
  </div>
</template>
<script>
  import ProfileParticipant from '@/components/widgets/ProfileParticipant';
  import Assingment from '@/components/widgets/Assingment';
  import CaseNotes from '@/components/widgets/CaseNotes';
  import Messages from '@/components/widgets/Messages';
  import Breadcrumbs from '@/components/Breadcrumbs'
  import {mapActions} from 'vuex';
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    mixins: [
      participantDisplayName
    ],

    beforeMount() {
      if (this.$route.params.id) {
        this.loadParticipant(this.$route.params.id);
      } else {
        this.loadParticipant('97');
      }
    },

    methods: {
      ...mapActions([
        'loadParticipant'
      ]),
    },

    components: {
      ProfileParticipant,
      Assingment,
      CaseNotes,
      Messages,
      Breadcrumbs
    },

    watch: {
      '$route.params.id': function () {
        this.loadParticipant(this.$route.params.id);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Messages.vue?7f13f9b5